import React from 'react';

export default function Home() {
    return (
        <main className="container mx-auto px-4 py-0 space-y-12">
            {/* Intro Section */}
            <section className="text-center max-w-3xl mx-auto">
                <h2 className="text-3xl md:text-4xl font-semibold mb-4 text-black">
                    Welcome to My Portfolio!
                </h2>
                <p className="text-lg md:text-xl text-black">
                    I'm <strong>Kritik Agarwal</strong>, an M.Tech student in Computer Science & Engineering at IIT Hyderabad.
                    I'm currently working on transformer-based models for generating synthetic Electronic Health Records.
                    I also have a keen interest in the cybersecurity domain.
                </p>
            </section>

            {/* Quick Highlights */}
            <section className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
                <div className="bg-white p-6 rounded-2xl shadow-md">
                    <h3 className="text-xl font-bold mb-2 text-black">🔬 Research</h3>
                    <p className="text-black">
                        Working on transformer-based models for generating synthetic Electronic Health Records using MIMIC-IV.
                    </p>
                </div>
                <div className="bg-white p-6 rounded-2xl shadow-md">
                    <h3 className="text-xl font-bold mb-2 text-black">🛡 Cybersecurity Enthusiast</h3>
                    <p className="text-black">
                        Passionate and eager to learn more about cyber security, and keeping digital systems safe from evolving threats and vulnerabilities.
                    </p>
                </div>
                <div className="bg-white p-6 rounded-2xl shadow-md">
                    <h3 className="text-xl font-bold mb-2 text-black">✍️ Blogs</h3>
                    <p className="text-black">
                        I write about my experiences and insights in the field of computer science and engineering.
                        <br />
                        <span className="text-gray-500"><a href="/#/blog" className="hover:underline ml-1">Check out my latest posts!</a></span>
                    </p>
                </div>
            </section>

            {/* Call to Action */}
            <section className="text-center bg-gray-100 rounded-2xl shadow-md px-6 py-8">
                <div className="flex items-center justify-center mb-3">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-800 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17v-6h13m-4-4l4 4-4 4" />
                    </svg>
                    <h3 className="text-2xl font-semibold text-black">Explore More</h3>
                </div>
                <p className="text-black mb-5">
                    Check out my full CV, or drop me a message!
                </p>
                <div className="flex justify-center gap-4 flex-wrap">
                    <a
                        href="/#/cv"
                        className="bg-blue-800 text-white px-5 py-2 rounded-full hover:bg-blue-700 transition"
                    >
                        View CV
                    </a>
                    <a
                        href="/#/contact"
                        className="bg-white border border-blue-800 text-blue-800 px-5 py-2 rounded-full hover:bg-blue-100 transition"
                    >
                        Contact Me
                    </a>
                </div>
            </section>

        </main>
    );
}